import React, { Component, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import Form from "../../../comman/form";
import auth from "../../../services/authService";
import config from "../../../config.json";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getActivateDeactivateLoading, getActivateDeactivateUpdateStatus, getUserAccessHistory, loadUserAccessLogHistory, updateUserActiveDeactive } from "../../../app/store/users";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { getCurrentUser } from "../../../app/store/auth";

const ActiveDeactiveHistory = (props) => {

  const { selectedObj, typeName, type, handlePermissionShowHide2 } = props;

  const [status, setStatus] = useState(null);
  const [notes, setNotes] = useState("");
  const [accessHistory, setAccessHistory] = useState([]);
  const [userId, setUserId] = useState(0);
  const [partnerId, setPartnerId] = useState(0);

  const userAccessHistorySelector = useSelector(getUserAccessHistory);
  const activateDeactivateUpdateStatusSelector = useSelector(getActivateDeactivateUpdateStatus);
  const isSubmitting = useSelector(getActivateDeactivateLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (selectedObj && type === "performer") {
      setStatus(selectedObj.status);
      setUserId(selectedObj.id);
      dispatch(loadUserAccessLogHistory(selectedObj.id, type));
    }
    if (selectedObj?.contact1 && type === "partner") {
      setPartnerId(selectedObj.fuid);
      setStatus(selectedObj.contact1.isActive);
      setUserId(selectedObj.contact1.performerid);
      dispatch(loadUserAccessLogHistory(selectedObj.fuid, type));
    }
    setNotes("");
  }, [selectedObj]);

  useEffect(() => {
    if (userAccessHistorySelector !== "")
      setAccessHistory(userAccessHistorySelector);
  }, [userAccessHistorySelector]);

  useEffect(() => {
    if (activateDeactivateUpdateStatusSelector) {
      let title = "Activate";
      if (!status) title = "Deactivate";
      getAlert("", `${title}d Successfully`, "success");
      handlePermissionShowHide2();
      if (type === "performer")
        dispatch(loadUserAccessLogHistory(userId, type));
      else
        dispatch(loadUserAccessLogHistory(partnerId, type));
    }

  }, [activateDeactivateUpdateStatusSelector]);

  const handleSubmit = async () => {
    let title = "Activate";
    if (!status) title = "Deactivate";
    const result = await getConfirmAlert("Warning", `Are you sure you want to ${title} the ${typeName}?`, "warning");
    if (result.isConfirmed) {
      const data = {
        addedBy: currentUser.id,
        status: status,
        notes: notes,
        performerId: userId,
        partnerId: partnerId
      };
      dispatch(updateUserActiveDeactive(data));
    }
  };

  return (
    <React.Fragment>
      <style>{`
        /* ── Scoped Style for ActiveDeactiveHistory ── */
        @keyframes adhFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .adh-container {
          animation: adhFadeIn 0.3s ease both;
          width: 100%;
        }

        /* ── Selected Item Banner ── */
        .adh-banner {
          display: flex; align-items: center; gap: 14px;
          padding: 14px 18px; border-radius: 0;
          background: #ffffff; border: 1.5px solid #e2e8f0;
          margin-bottom: 20px;
        }
        .adh-banner-icon {
          width: 38px; height: 38px; border-radius: 0;
          background: #f5f5f5; color: #525252; border: 1px solid #d4d4d4;
          display: flex; align-items: center; justify-content: center;
          font-size: 16px; flex-shrink: 0;
        }
        .adh-banner-text { display: flex; flex-direction: column; }
        .adh-banner-label { font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.7px; }
        .adh-banner-value { font-size: 14.5px; font-weight: 600; color: #0f172a; margin-top: 1px; }

        /* ── Interactive Radio Cards ── */
        .adh-status-row { display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap; width: 100%; }
        .adh-radio-card {
          flex: 1; min-width: 160px; border: 2px solid #e2e8f0; border-radius: 0;
          padding: 14px 16px; display: flex; align-items: center; gap: 12px;
          cursor: pointer; transition: all 0.25s ease; position: relative;
          background: #ffffff; user-select: none;
        }
        .adh-radio-card:hover {
          border-color: #cbd5e1; background: #f8fafc;
          transform: translateY(-1px); box-shadow: 0 4px 12px rgba(15,23,42,0.03);
        }
        .adh-radio-card-icon {
          width: 36px; height: 36px; border-radius: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; background: #f1f5f9; color: #64748b; transition: all 0.2s ease;
        }
        .adh-radio-card.active-state.active {
          border-color: #10b981; background: #ffffff;
          box-shadow: 0 4px 16px rgba(16,185,129,0.06);
        }
        .adh-radio-card.active-state.active .adh-radio-card-icon {
          background: rgba(16,185,129,0.1); color: #059669;
        }
        .adh-radio-card.inactive-state.active {
          border-color: #ef4444; background: #ffffff;
          box-shadow: 0 4px 16px rgba(239,68,68,0.06);
        }
        .adh-radio-card.inactive-state.active .adh-radio-card-icon {
          background: rgba(239,68,68,0.1); color: #dc2626;
        }
        .adh-radio-card-content { display: flex; flex-direction: column; text-align: left; }
        .adh-radio-card-title { font-size: 13px; font-weight: 600; color: #1e293b; }
        .adh-radio-card-desc { font-size: 11px; color: #64748b; margin-top: 2px; line-height: 1.3; }
        .adh-radio-card-badge {
          position: absolute; top: 12px; right: 12px;
          font-size: 15px; line-height: 1;
        }
        .adh-radio-card.active-state.active .adh-radio-card-badge { color: #10b981; }
        .adh-radio-card.inactive-state.active .adh-radio-card-badge { color: #ef4444; }

        /* ── Notes Block ── */
        .adh-notes-group { margin-bottom: 22px; width: 100%; }
        .adh-notes-group label {
          font-size: 11px; font-weight: 600; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.7px; margin-bottom: 6px;
          display: flex; align-items: center; gap: 5px;
        }
        .adh-notes-group label i { color: #94a3b8; font-size: 11px; }
        .adh-notes-group textarea {
          border-radius: 0 !important; border: 1.5px solid #e2e8f0 !important;
          padding: 10px 14px !important; font-size: 13px !important;
          color: #1e293b !important; background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
          resize: vertical !important; min-height: 70px;
        }
        .adh-notes-group textarea:hover {
          border-color: #94a3b8 !important; box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }
        .adh-notes-group textarea:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
          outline: none !important; background: #fafbff !important;
        }

        /* ── Action Buttons ── */
        .adh-submit-btn {
          min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px; font-weight: 600; border-radius: 0;
          cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 24px; border: 1px solid transparent; outline: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }
        .adh-submit-btn.btn-active-state {
          background: #10b981; color: white;
        }
        .adh-submit-btn.btn-active-state:hover {
          background: #059669; transform: translateY(-1px);
          box-shadow: 0 10px 15px -3px rgba(16,185,129,0.12);
        }
        .adh-submit-btn.btn-inactive-state {
          background: #ef4444; color: white;
        }
        .adh-submit-btn.btn-inactive-state:hover {
          background: #dc2626; transform: translateY(-1px);
          box-shadow: 0 10px 15px -3px rgba(239,68,68,0.12);
        }

        .adh-cancel-btn {
          min-height: 38px; display: inline-flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px; font-weight: 600; border-radius: 0;
          cursor: pointer; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 8px 16px; border: 1.5px solid #cbd5e1; outline: none;
          background: #ffffff; color: #475569;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }
        .adh-cancel-btn:hover {
          background: #f8fafc; border-color: #94a3b8; color: #1e293b;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }

        .adh-submit-btn:disabled, .adh-submit-btn:disabled:hover,
        .adh-cancel-btn:disabled, .adh-cancel-btn:disabled:hover {
          opacity: 0.6; cursor: not-allowed;
          transform: none; box-shadow: none;
        }

        /* ── History Table Styling ── */
        .adh-history-title {
          font-size: 11px; font-weight: 600; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.7px; margin-top: 28px; margin-bottom: 12px;
          display: flex; align-items: center; gap: 6px; width: 100%;
        }
        .adh-history-title i { color: #94a3b8; font-size: 12px; }

        .adh-table-scroll table,
        table.adh-table {
          width: 100% !important; border-collapse: collapse !important; border: 1px solid #cbd5e1 !important;
        }
        .adh-thead th {
          background: #f8fafc !important; color: #475569 !important; font-size: 10.5px !important;
          font-weight: 600 !important; text-transform: uppercase !important; letter-spacing: 0.8px !important;
          padding: 10px 16px !important; border: none !important; border-bottom: 2px solid #e2e8f0 !important;
        }
        .adh-table-row {
          background: #ffffff !important; transition: all 0.2s ease !important;
        }
        .adh-table-row:hover {
          background: #f5f5f5 !important;
        }
        .adh-table-row td {
          padding: 10px 16px !important; font-size: 13px !important; color: #334155 !important;
          border-left: none !important; border-right: none !important; border-bottom: 1px solid #f1f5f9 !important; vertical-align: middle !important;
        }
        table.adh-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        /* Badge Capsules */
        .badge-capsule {
          display: inline-flex !important; align-items: center !important; justify-content: center !important;
          gap: 5px !important; padding: 4px 8px !important; border-radius: 0 !important;
          width: 96px !important; min-width: 96px !important; text-align: center !important;
          font-size: 11px !important; font-weight: 500 !important;
          line-height: 1 !important; text-transform: uppercase !important; letter-spacing: 0.5px !important;
          box-sizing: border-box !important;
        }
        .badge-capsule i { font-size: 10px; }
        .badge-capsule.badge-active {
          background: rgba(16,185,129,0.08) !important; color: #059669 !important;
          border: 1px solid rgba(16,185,129,0.15) !important;
        }
        .badge-capsule.badge-inactive {
          background: rgba(239,68,68,0.08) !important; color: #dc2626 !important;
          border: 1px solid rgba(239,68,68,0.15) !important;
        }

        /* ── Split Grid Columns Styling ── */
        @media (min-width: 992px) {
          .adh-left-col {
            border-right: 1px solid #f1f5f9;
            padding-right: 28px;
          }
          .adh-right-col {
            padding-left: 28px;
          }
          .adh-right-col .adh-history-title {
            margin-top: 0;
          }
        }

        /* ── Back Button Header ── */
        .adh-back-header {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 18px;
          width: 100%;
        }
        .adh-back-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          border-radius: 0;
          padding: 8px 16px;
          font-size: 13px;
          font-weight: 600;
          color: #475569;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          outline: none;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }
        .adh-back-btn:hover {
          border-color: #cbd5e1;
          color: #1f2937;
          background: #f8fafc;
          transform: translateX(-2px);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
        }
        .adh-back-btn i {
          font-size: 12px;
          transition: transform 0.2s ease;
        }
        .adh-back-btn:hover i {
          transform: translateX(-1px);
        }
      `}</style>

      <div className="adh-container">
        <div className="row">

          {/* Left Column: Status Action Form */}
          <div className="col-lg-5 col-md-12 adh-left-col">
            {/* Selected Item Banner */}
            <div className="adh-banner">
              <div className="adh-banner-icon">
                <i className={type === "partner" ? "fa fa-handshake-o" : "fa fa-user"} />
              </div>
              <div className="adh-banner-text">
                <span className="adh-banner-label">Selected {typeName}</span>
                <strong className="adh-banner-value">
                  {type === "partner" ? selectedObj?.label : selectedObj?.name}
                </strong>
              </div>
            </div>

            {/* Interactive Radio Cards */}
            <div className="adh-status-row">
              <div
                className={`adh-radio-card active-state${status ? " active" : ""}`}
                onClick={() => setStatus(true)}
                role="button" tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && setStatus(true)}
              >
                <div className="adh-radio-card-icon"><i className="fa fa-toggle-on" /></div>
                <div className="adh-radio-card-content">
                  <span className="adh-radio-card-title">Activate</span>
                  <span className="adh-radio-card-desc">Enable access and active status</span>
                </div>
                {status && (
                  <div className="adh-radio-card-badge"><i className="fa fa-check-circle" /></div>
                )}
              </div>

              <div
                className={`adh-radio-card inactive-state${status === false ? " active" : ""}`}
                onClick={() => setStatus(false)}
                role="button" tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && setStatus(false)}
              >
                <div className="adh-radio-card-icon"><i className="fa fa-toggle-off" /></div>
                <div className="adh-radio-card-content">
                  <span className="adh-radio-card-title">Deactivate</span>
                  <span className="adh-radio-card-desc">Revoke access and disable status</span>
                </div>
                {status === false && (
                  <div className="adh-radio-card-badge"><i className="fa fa-check-circle" /></div>
                )}
              </div>
            </div>

            {/* Notes Form Field */}
            <div className="adh-notes-group">
              <label htmlFor="notes">
                <i className="fa fa-commenting-o" /> Notes
              </label>
              <textarea
                name="notes"
                id="notes"
                rows="3"
                value={notes}
                placeholder="Add a reason or optional notes for this status update…"
                className="form-control"
                onChange={({ currentTarget }) => setNotes(currentTarget.value)}
              />
            </div>

            {/* Actions Section */}
            <div className="adh-actions-row" style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginBottom: "20px" }}>
              <button
                type="button"
                className="adh-cancel-btn"
                onClick={handlePermissionShowHide2}
                disabled={isSubmitting}
              >
                <i className="fa fa-arrow-left" aria-hidden="true" /> Back
              </button>
              <button
                type="button"
                className={`adh-submit-btn ${status ? "btn-active-state" : "btn-inactive-state"}`}
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                    {status ? "Activating…" : "Deactivating…"}
                  </>
                ) : (
                  <>
                    <i className="fa fa-check" aria-hidden="true" />
                    {status ? `Activate ${typeName}` : `Deactivate ${typeName}`}
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Right Column: History Log */}
          <div className="col-lg-7 col-md-12 adh-right-col">
            {/* History Log Title */}
            <div className="adh-history-title">
              <i className="fa fa-history" />
              <span>Status Update History</span>
            </div>

            {/* History Table */}
            <div className="table-responsive wf-table-scroll" style={{ border: "none", borderRadius: "0", overflow: "auto" }}>
              <table className="table adh-table m-0">
                <thead className="adh-thead">
                  <tr>
                    <th>Date &amp; Time</th>
                    <th>Notes</th>
                    <th>Action By</th>
                    <th style={{ width: "130px", textAlign: "center" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {accessHistory.length === 0 ? (
                    <tr className="adh-table-row">
                      <td colSpan={4} className="text-center py-4 text-muted" style={{ fontSize: "12.5px" }}>
                        <i className="fa fa-info-circle mr-1" /> No status history records found.
                      </td>
                    </tr>
                  ) : (
                    accessHistory.map((item, key) => (
                      <tr key={`history-${key}`} className="adh-table-row">
                        <td style={{ whiteSpace: "nowrap", fontWeight: 400 }}>
                          <Moment format="MMM Do YYYY, h:mm a">
                            {item.addedDateTime}
                          </Moment>
                        </td>
                        <td style={{ minWidth: "200px" }}>{item.notes || <span className="text-muted" style={{ fontStyle: "italic" }}>— No notes provided —</span>}</td>
                        <td>{item.performerName}</td>
                        <td>
                          {item.status ? (
                            <span className="badge-capsule badge-active">
                              <i className="fa fa-check" aria-hidden="true" />
                              Activated
                            </span>
                          ) : (
                            <span className="badge-capsule badge-inactive">
                              <i className="fa fa-times" aria-hidden="true" />
                              Deactivated
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </React.Fragment>
  );
}

export default ActiveDeactiveHistory;
